import React, { useEffect, useRef, useState } from 'react'
import Layout from '../common/Layout'
import ApiHelper from '../../helperFunction/ApiHelper'
import API_ENDPOINTS from '../../helperFunction/Constant'
import { Link, useNavigate } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import { Toast } from 'primereact/toast'
import { IconField } from 'primereact/iconfield'
import { InputIcon } from 'primereact/inputicon'
import { InputText } from 'primereact/inputtext'


const Notifications = () => {

    const toast = useRef(null)
    const [notificationsData, setNotifications] = useState([])

    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const navigate = useNavigate()

    useEffect(() => {
        getNotifications()
    }, [])

    const getNotifications = () => {
        ApiHelper.get(API_ENDPOINTS.NOTIFICATIONS).then((res) => {
            if (res.status === 200) {
                setNotifications(res.data.data)
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const serialNoTemplate = (rowData, options) => { return options.rowIndex + 1; };

    const nameBodyTemplate = (rowData) => {
        return (
            rowData?.title ? (
                <div style={{ display: "flex", alignItems: "center", gap: "10px", color:'blue', cursor:'pointer' }} onClick={() => navigate(`/notifications/edit/${rowData.notificationId}`)} >
                    {rowData?.title}
                </div>
            ) : null
        );
    };

    const imageBodyTemplate = (rowData) => {
        return (
            rowData.imageUrl ? (
                <img src={`${process.env.REACT_APP_BASE_URL}/${rowData.imageUrl}`} onError={(e) => { e.target.src = "/img/placeholder-image.jpg" }} alt="" style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
            ) : (
                <i className="pi pi-image"></i>
            )
        );
    };

    const statusBodyTemplate = (rowData) => {
        return (
            <span className={`badge ${rowData.isActive ? 'bg-success' : 'bg-danger'}`}>
                {rowData.isActive ? 'Active' : 'Inactive'}
            </span>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <button onClick={() => navigate(`/notifications/edit/${rowData.notificationId}`)} className="btn btn-primary btn-sm me-2"> <i class="bi bi-pencil-square"></i> </button>
                <button onClick={() => confirmDeleteDailog(rowData.notificationId)} className="btn btn-danger btn-sm"> <i class="bi bi-trash"></i> </button>
            </>
        );
    };

    const confirmDeleteDailog = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: null,
            acceptClassName: 'p-button-danger',
            accept: () => deleteNotifications(id),
        });
    };

    const deleteNotifications = (id) => {
        ApiHelper.delete(`${API_ENDPOINTS.NOTIFICATIONS}/${id}`).then((res) => {
            if (res.status === 200) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: res.data.message, life: 3000 })
                getNotifications()
            }
        }).catch((error) => {
            console.log("Error: ", error);
        })
    }

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={(e) => setGlobalFilterValue(e.target.value)} placeholder="Search" />
                </IconField>
            </div>
        );
    };

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />
            <Layout>
                <div class="content-wrapper">
                    <div class="container-xxl flex-grow-1 container-p-y">
                        <div class="d-flex justify-content-between align-items-center py-3">
                            <h4 class="fw-bold py-3"><span class="text-muted fw-light"><p className="breadcrumb-item active mb-0" aria-current="page">Notifications</p></span></h4>
                            <Link class="btn btn-primary" to={'/notifications/add'} >Add New Notifications</Link>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="card mb-4">
                                    <div class="card-body">
                                        <DataTable globalFilter={globalFilterValue} header={renderHeader} paginator rows={50} rowsPerPageOptions={[50, 100, 150, 200]} showGridlines size="small" value={notificationsData} tableStyle={{ minWidth: '50rem' }} >
                                            <Column body={serialNoTemplate} header='S.NO' />
                                            <Column sortable header='Title' body={nameBodyTemplate} field='title' />
                                            <Column sortable header='Body' field='body' />
                                            <Column sortable header='Image' body={imageBodyTemplate} field='imageUrl' />
                                            <Column sortable header='Type' field='type' />
                                            <Column sortable header='Action Text' field='actionText' />
                                            <Column sortable header='Action' body={actionBodyTemplate} />
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default Notifications
